import { render } from "./CampaignsFilter.vue?vue&type=template&id=0d4836b6"
import script from "./CampaignsFilter.vue?vue&type=script&lang=js"
export * from "./CampaignsFilter.vue?vue&type=script&lang=js"

import "./CampaignsFilter.vue?vue&type=style&index=0&id=0d4836b6&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__